export class FolderHistoryChangeNotification {
    public folderId: string;
    public viewId: number;

    public static fromJson(other: any): FolderHistoryChangeNotification {
        const instance = new FolderHistoryChangeNotification();
        instance.viewId = other.ViewId;
        instance.folderId = other.FolderId;
        return instance;
    }
}
